import { observable } from "mobx";
import { assert } from "./utils/assert";

export const state = observable({
  _uniqueUserId: undefined as undefined | string,
  get uniqueUserId() {
    assert(this._uniqueUserId !== undefined, "uniqueUserId is not set");
    return this._uniqueUserId;
  },
  localUserDetails: {
    name: undefined as undefined | string,
    age: undefined as undefined | number,
    sex: undefined as undefined | "male" | "female" | "other",
  },
  preferredIsLocalMicOn: true,
  preferredCameraFacingMode: undefined as undefined | "user" | "environment",
  videoInputDeviceId: undefined as undefined | string,
  audioInputDeviceId: undefined as undefined | string,
  preferredAudioOutput: "SPEAKER" as
    | "SPEAKER"
    | "BLUETOOTH"
    | "WIRED_HEADSET"
    | undefined,
});
